import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Input,
  Spinner,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import { useInviteUser } from "../hooks/useIdentityMutations";

function IdentityInvite({ isOpen, setIsOpen, onSuccess }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");

  const { mutate, isPending, error, reset } = useInviteUser(
    (data) => {
      onSuccess?.(data);
      setEmail("");
      setIsOpen(false);
    },
    null,
    true,
  );

  const handleClose = () => {
    if (isPending) return;
    reset();
    setEmail("");
    setIsOpen(false);
  };

  const handleSendInvite = () => {
    const sanitizedEmail = email.trim();
    if (!sanitizedEmail) return;
    mutate(sanitizedEmail);
  };

  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && handleClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogContent>
            <Field label={t("generic.email")} required>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSendInvite();
                  }
                }}
              />
            </Field>
            {error && <div style={{ color: "red", marginTop: "0.5rem" }}>{error.message}</div>}
          </DialogContent>
        </DialogBody>
        <DialogActions style={{ margin: "20px 0 0 0" }}>
          <Button appearance="secondary" onClick={handleClose} disabled={isPending}>
            {t("generic.cancel")}
          </Button>
          <Button appearance="primary" onClick={handleSendInvite} disabled={isPending || !email.trim()}>
            {isPending ? <Spinner size="tiny" /> : t("generic.invite")}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}

export default IdentityInvite;
